import * as React from 'react';
import {useEffect, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import logo from "../../assets/logo2.svg";
import {useTheme} from "@mui/material/styles";
import {Autocomplete, IconButton, Menu, MenuItem, TextField, Typography} from "@mui/material";
import {useAppDispatch, useAppSelector} from "../hooks";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ChangePasswordModal from "../../features/auth/change-password.component";
import {logout, setCurrentClient} from "../../features/auth/auth.slice";
import {makeStyles} from "@mui/styles";

function AppMenu() {
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const authState = useAppSelector((state) => state.auth);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const [showChangePassword, setShowChangePassword] = useState<boolean>(false);
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const exit = () => {
        dispatch(logout());
        window.location.href = '/'
    };

    const changePassword = () => {
        setShowChangePassword(true);
        setAnchorElUser(null);
    };


    const useStyles = makeStyles((defaultTheme) => ({
        root: {
            color: `${theme.palette.secondary.main} !important`,
            border: `0px solid ${theme.palette.secondary.main} !important`,
            '& *': {
                color: `${theme.palette.secondary.main} !important`,
                borderColor: `${theme.palette.secondary.main} !important`,
            }
        }
    }));

    useEffect(() => {
        if (authState.user?.clients[0]){
            const currentClient = localStorage.getItem("currentClient")
            let client = null;
            if (currentClient) {
                client = authState.user?.clients.find(c => c.id.toString()===currentClient)
            }
            if (!client) {
                client = authState.user?.clients[0]
            }
            dispatch(setCurrentClient(client))
        }
    }, [authState.user?.clients])

    const style = useStyles();

    return (
        <Box sx={{ flexGrow: 1, position: 'relative', zIndex: 10 }}>
        <AppBar position="static" sx={{backgroundColor: theme.palette.primary.main}}>
                <Toolbar disableGutters sx={{position: 'flex', justifyContent: 'right', minHeight: '80px !important'}}>
                    <img alt="Wink" src={logo} height='80' width='150' style={{marginLeft: '40px', flexGrow: 1, position: 'absolute', left: 0}}/>
                    {authState.user?.clients.length && authState.user?.clients.length>1 && <Box sx={{flexGrow: 0, marginRight: '50px'}}>
                            <Autocomplete sx={{minWidth: '400px'}}
                                classes={style}
                                value={authState.currentClient || null}
                                disablePortal
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                options={authState.user?.clients || []}
                                onChange={(event, value) => {
                                    if (value) {
                                        dispatch(setCurrentClient(value))
                                    }
                                }}
                                getOptionLabel={(o) => o.name}
                                renderInput={(params) => <TextField {...params} label="Empresa"/>}/>
                    </Box>}
                    <Box sx={{flexGrow: 0, display: { xs: 'none', sm: 'block'}}}>
                        <span style={{color: `${theme.palette.secondary.main}`, float: 'right', position: 'relative', top: '6px', marginRight: '15px', fontWeight: 900}}>Olá, {authState.user?.name}</span>
                    </Box>
                    <Box sx={{marginRight: '40px'}}>
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, fontSize: '110%' }} color="secondary">
                            <AccountCircleIcon sx={{ fontSize: 40 }}></AccountCircleIcon>
                        </IconButton>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <MenuItem onClick={changePassword}>
                                <Typography textAlign="center">Alterar Senha</Typography>
                            </MenuItem>
                            <MenuItem onClick={exit}>
                                <Typography textAlign="center">Sair</Typography>
                            </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
                <ChangePasswordModal open={showChangePassword} onClose={() => setShowChangePassword(false)}/>
        </AppBar>
        </Box>
    );
}

export default AppMenu;
